import { Global } from '@emotion/react';

export const PrintStyles = () => (
  <Global
    styles={`
      @media all {
        .page-break {
          display: none;
        }
      }

      @media print {
        html,
        body {
          height: initial !important;
          overflow: initial !important;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        .page-break {
          margin-top: 1rem;
          display: block;
          page-break-before: auto;
        }

        @page {
          size: 5cm 2cm;
          size: portrait;
          margin: auto;
        }
      }
    `}
  />
);
